import React, { useRef, useEffect, useState, useLayoutEffect } from "react"
import Form from "./form"
import style from "./style.module.scss"

function Index() {
  const [openForm, setOpenForm] = useState(undefined)
  const containerRef = useRef()
  const movementHandler = useRef()
  let canvas
  let canvasMiddle
  const inititalStep = 20
  let step = inititalStep
  // One key press = one tick.
  let tick = 0
  let draw
  let drawRef = useRef(draw)
  let rafid
  // Images to draw.
  const obstacles = []
  const items = []
  let unit
  let unitHeight
  let elAttached = false
  const coverRef = useRef()
  let drawn = 0 // should reach 12?
  let isFirefox = undefined

  // Player.
  const player = {
    direction: "up",
    width: undefined,
    height: undefined,
    x: undefined,
    y: undefined,
    isMiddle: false,
    canMove: true,
    checkIfIsMiddle() {
      const playerMiddle = this.y + this.height / 2
      this.isMiddle = false
      // Player should go straight to the middle.
      const lastStep = Math.abs(playerMiddle - canvasMiddle)
      if (lastStep < step) step = lastStep
      // If reached middle.
      if (playerMiddle === canvasMiddle) {
        step = inititalStep
        this.isMiddle = true
      }
    },
    checkIfCanMove() {
      switch (this.direction) {
        case "up":
          if (this.y > 0) this.canMove = true
          else this.canMove = false
          break
        case "down":
          if (this.y + this.height < canvas.height) this.canMove = true
          else this.canMove = false
          break
        case "left":
          if (this.x > 0) this.canMove = true
          else this.canMove = false
          break
        case "right":
          if (this.x + this.width < canvas.width) this.canMove = true
          else this.canMove = false
          break

        default:
          break
      }
      return this.canMove
    },
    moveUp() {
      this.y -= step
    },
    moveDown() {
      this.y += step
    },
    moveLeft() {
      this.x -= step
    },
    moveRight() {
      this.x += step
    },
  }

  // Camera.
  const camera = {
    yUpperLimit: undefined,
    yLowerLimit: 0,
    yTop: 0,
    reachedUpperLimit() {
      if (this.yTop <= this.yUpperLimit) return true
    },
    reachedLowerLimit() {
      if (this.yTop >= this.yLowerLimit) return true
    },
    moveDown() {
      this.yTop += step
    },
    moveUp() {
      this.yTop -= step
    },
  }

  // Clear canvas.
  const clear = () => {
    const ctx = canvas.getContext("2d")
    ctx.clearRect(0, 0, canvas.width, canvas.height)
  }

  // Hide cover(loading).
  const hideCover = () => {
    console.log(drawn)
    if (drawn >= 12) coverRef.current.style.display = "none"
  }

  // Append canvas, style it, define variables.
  useEffect(() => {
    document.body.setAttribute("style", "overflowY: scroll")
    canvas = document.createElement("canvas")
    canvas.setAttribute("width", window.innerWidth)
    canvas.setAttribute("height", window.innerHeight)
    canvas.setAttribute(
      "style",
      "background-color: gray; background-image: url(/static/img/svg/background.svg); background-repeat: no-repeat; background-size: cover; "
    )

    camera.yUpperLimit = -canvas.height * 4.5

    unit = canvas.width / 13
    unitHeight = Math.abs((canvas.height + camera.yUpperLimit) / 20)

    containerRef.current.appendChild(canvas)
    canvasMiddle = canvas.height / 2
    player.width = unit
    player.height = player.width
    player.x = canvas.width / 2 - player.width / 2
    player.y = canvas.height - player.height

    isFirefox = navigator.userAgent.indexOf("Firefox") > 0 ? true : false
  }, [])

  // Animate.
  useEffect(() => {
    // Image.
    class Img extends Image {
      constructor(
        name,
        src,
        srcCoords,
        destinationCoords,
        scale,
        width,
        height,
        framesTotal,
        rowsTotal
      ) {
        const newImage = super()
        this.image = newImage
        this.ctx = canvas.getContext("2d")
        this.src = src
        this.srcCoords = srcCoords
        this.destinationCoords = destinationCoords
        this.width = width
        this.height = height
        this.isFirstLoad = true
        this.row = 1
        this.name = name

        this.wait = false

        this.scale = scale

        this.rowsTotal = rowsTotal

        // Control animation.
        this.framesTotal = framesTotal

        this.colliding = false
        this.triggered = false
        this.triggeredAgain = false
        this.collided = false

        this.destinationCoordsSnap = destinationCoords

        this.newDots = 0
      }

      checkIsColliding(offset) {
        switch (player.direction) {
          case "up":
            // If left or right or top.
            if (
              player.x + player.width <= this.destinationCoords.x ||
              player.x >= this.destinationCoords.x + this.scale.x ||
              player.y + player.height <= this.destinationCoords.y
            ) {
              this.colliding = false
            } else if (
              player.y <=
              this.destinationCoords.y + this.scale.y + offset
            ) {
              this.colliding = true
            } else if (player.y > this.destinationCoords.y + this.scale.y) {
              this.colliding = false
              this.destinationCoordsSnap = this.destinationCoords
            }

            break
          case "down":
            // If left or right or bottom.
            if (
              player.x + player.width <= this.destinationCoords.x ||
              player.x >= this.destinationCoords.x + this.scale.x ||
              player.y >= this.destinationCoords.y + this.scale.y
            )
              this.colliding = false
            // If reached obstacle.
            else if (
              player.y + player.height + offset >=
              this.destinationCoords.y
            ) {
              this.colliding = true
            } else if (player.y + player.height < this.destinationCoords.y)
              this.colliding = false

            break
          case "left":
            // If top or bottom or left.
            if (
              player.y + player.height <= this.destinationCoords.y ||
              player.y >= this.destinationCoords.y + this.scale.y ||
              player.x + player.width <= this.destinationCoords.x
            )
              this.colliding = false
            else if (
              player.x <=
              this.destinationCoords.x + this.scale.x + offset
            ) {
              this.colliding = true
            } else if (player.x > this.destinationCoords.x + this.scale.x)
              this.colliding = false

            break
          case "right":
            // If top or bottom or right.
            if (
              player.y + player.height <= this.destinationCoords.y ||
              player.y >= this.destinationCoords.y + this.scale.y ||
              player.x >= this.destinationCoords.x + this.scale.x
            )
              this.colliding = false
            // Reached obstacle.
            else if (
              player.x + player.width + offset >=
              this.destinationCoords.x
            ) {
              this.colliding = true
            } else if (player.x + player.width < this.destinationCoords.x)
              this.colliding = false

            break

          default:
            break
        }
      }

      move({ x, y }) {
        this.destinationCoords = {
          x: this.destinationCoords.x + x,
          y: this.destinationCoords.y + y,
        }
      }

      changeFrame(frame) {
        this.srcCoords.x = (frame - 1) * this.width
      }

      animate() {
        let currentFrame = 2
        let fps = 30
        if (this.name === "book") fps = 10
        else if (this.name === "pen") fps = 50
        this.wait = true

        const animation = () => {
          setTimeout(() => {
            this.changeFrame(currentFrame)
            draw()

            currentFrame++

            if (currentFrame <= this.framesTotal)
              rafid = requestAnimationFrame(animation)
            // Finished animation.
            else {
              this.wait = false
              this.collided = true
              rafid = requestAnimationFrame(draw)
            }
          }, 1000 / fps)
        }

        if (this.framesTotal > 1) rafid = requestAnimationFrame(animation)
      }

      changeSpriteRow(row) {
        this.row = row + this.newDots * 4
        this.srcCoords.y = (this.row - 1) * this.height
      }

      gotNewDot() {
        this.newDots = this.newDots + 1
        let row = 1
        switch (player.direction) {
          case "down":
            row = 4
            break
          case "left":
            row = 2
            break
          case "right":
            row = 3
            break

          default:
            break
        }
        this.changeSpriteRow(row)
        rafid = requestAnimationFrame(draw)
      }

      goFinalFrame() {
        this.changeSpriteRow(this.rowsTotal)
        this.changeFrame(1)
        rafid = requestAnimationFrame(draw)
      }

      drawAllDots() {
        this.newDots = 4
        let row = 1
        switch (player.direction) {
          case "down":
            row = 4
            break
          case "left":
            row = 2
            break
          case "right":
            row = 3
            break

          default:
            break
        }
        this.changeSpriteRow(row)
      }

      draw() {
        const drawImage = () => {
          this.ctx.drawImage(
            this.image,
            this.srcCoords.x,
            this.srcCoords.y,
            this.width,
            this.height,

            this.destinationCoords.x,
            this.destinationCoords.y,
            this.scale.x,
            this.scale.y
          )
          this.isFirstLoad = false
          // Everything is drawn.
          hideCover()
          drawn++
        }
        if (this.isFirstLoad) {
          this.image.addEventListener("load", drawImage)
        } else {
          drawImage()
        }

        this.image.src = this.src
      }
    }

    const mainChar = new Img(
      "mainChar",
      "/static/img/svg/cockroach.svg",
      { x: 0, y: 0 },
      { x: player.x, y: player.y },
      { x: player.width, y: player.height },
      180,
      180,
      2,
      4
    )
    const e = new Img(
      "e",
      "/static/img/svg/e.svg",
      { x: 0, y: 0 },
      { x: 100, y: 100 },
      { x: player.width, y: player.height },
      100,
      100,
      1,
      1
    )
    const e_contact = new Img(
      "e",
      "/static/img/svg/e_contact.svg",
      { x: 0, y: 0 },
      { x: 100, y: 100 },
      { x: player.width, y: player.height },
      100,
      100,
      1,
      1
    )
    const croissant = new Img(
      "croissant",
      "/static/img/svg/croissant.svg",
      { x: 0, y: 0 },
      { x: -unit * 2, y: -unitHeight * 2 },
      { x: isFirefox ? 600 : unit * 7, y: isFirefox ? 595 : unit * 6.5 },
      890,
      880,
      10,
      3
    )
    const notebook = new Img(
      "notebook",
      "/static/img/svg/notebook.svg",
      { x: 0, y: 0 },
      { x: unit * 8, y: -unitHeight * 26 },
      { x: unit * 7, y: unit * 10 },
      760,
      1110,
      7,
      1
    )
    const coffee = new Img(
      "coffee",
      "/static/img/svg/coffee.svg",
      { x: 0, y: 0 },
      { x: unit * 8, y: -unitHeight * 10 },
      { x: unit * 6, y: unit * 6.3 },
      470,
      490,
      9,
      3
    )
    const pen = new Img(
      "pen",
      "/static/img/svg/pen.svg",
      { x: 0, y: 0 },
      { x: unit * 9, y: -unitHeight * 17 },
      { x: unit * 7, y: unit * 7.5 },
      840,
      880,
      10,
      3
    )
    const book = new Img(
      "book",
      "/static/img/svg/book.svg",
      { x: 0, y: 0 },
      { x: -unit * 3, y: -unitHeight * 17 },
      { x: isFirefox ? 930 : unit * 9, y: isFirefox ? 1050 : unit * 9.5 },
      930,
      1050,
      8,
      3
    )
    const paper = new Img(
      "paper",
      "/static/img/svg/paper.svg",
      { x: 0, y: 0 },
      { x: unit * 6, y: unitHeight * 2 },
      { x: unit * 6, y: unit * 6.2 },
      544.911,
      577.782,
      1,
      1
    )
    const business_card = new Img(
      "business_card",
      "/static/img/svg/business_card.svg",
      { x: 0, y: 0 },
      { x: unit / 2, y: -unitHeight * 7 },
      { x: unit * 5.5, y: unit * 4 },
      566,
      420,
      1,
      1
    )
    const business_card1 = new Img(
      "business_card",
      "/static/img/svg/business_card.svg",
      { x: 0, y: 0 },
      { x: -unit / 5, y: -unitHeight * 23 },
      { x: unit * 5.5, y: unit * 4 },
      566,
      420,
      1,
      1
    )
    const paper_clips = new Img(
      "paper_clips",
      "/static/img/svg/paper_clips.svg",
      { x: 0, y: 0 },
      { x: unit * 2, y: -unitHeight * 28 },
      { x: unit * 7, y: unit * 7 },
      568.688,
      553.031,
      1,
      1
    )
    const envelope = new Img(
      "envelope",
      "/static/img/svg/envelope.svg",
      { x: 0, y: 0 },
      { x: unit * 9, y: -unitHeight * 4.5 },
      { x: unit * 7, y: unit * 7.5 },
      430,
      460,
      1,
      1
    )
    obstacles.push(book, croissant, notebook, coffee, pen)
    items.push(paper_clips, paper, business_card, business_card1, envelope)

    let touch = { x: undefined, y: undefined }
    let touchstartX = 0
    let touchstartY = 0
    let touchendX = 0
    let touchendY = 0
    let offset = 10
    let direction

    // Key press or touch event handler (when 'e' is pressed).
    const handler = ({ key }) => {
      // Key press event.
      if (key === "e" || key === "у") {
        obstacles.forEach(obstacle => {
          // Find colliding obstacle.
          if (
            obstacle.colliding &&
            !obstacle.triggered &&
            obstacle.rowsTotal > 1 &&
            !obstacle.wait &&
            !obstacle.triggeredAgain
          ) {
            obstacle.triggered = true
            obstacle.changeSpriteRow(2)
            obstacle.animate()
          } else if (
            obstacle.colliding &&
            obstacle.collided &&
            !obstacle.wait &&
            obstacle.triggered &&
            !obstacle.triggeredAgain &&
            obstacle.rowsTotal > 2
          ) {
            obstacle.triggeredAgain = true
            obstacle.goFinalFrame()
            mainChar.gotNewDot()
          }
        })
      }
      // Touch event.
      else if (touch.x && touch.y) {
        obstacles.forEach(obstacle => {
          // Find colliding obstacle.
          if (
            obstacle.colliding &&
            !obstacle.triggered &&
            obstacle.rowsTotal > 1 &&
            !obstacle.wait &&
            !obstacle.triggeredAgain
          ) {
            // If touched inside the obstacle.
            if (
              touch.x >= obstacle.destinationCoords.x &&
              touch.x <= obstacle.destinationCoords.x + obstacle.scale.x &&
              touch.y >= obstacle.destinationCoords.y &&
              touch.y <= obstacle.destinationCoords.y + obstacle.scale.y
            ) {
              obstacle.triggered = true
              obstacle.changeSpriteRow(2)
              obstacle.animate()
            }
          }
          // Second trigger.
          else if (
            obstacle.colliding &&
            obstacle.collided &&
            !obstacle.wait &&
            obstacle.triggered &&
            !obstacle.triggeredAgain &&
            obstacle.rowsTotal > 2
          ) {
            // If touched inside the obstacle.
            if (
              touch.x >= obstacle.destinationCoords.x &&
              touch.x <= obstacle.destinationCoords.x + obstacle.scale.x &&
              touch.y >= obstacle.destinationCoords.y &&
              touch.y <= obstacle.destinationCoords.y + obstacle.scale.y
            ) {
              obstacle.triggeredAgain = true
              obstacle.goFinalFrame()
              mainChar.gotNewDot()
            }
          }
        })
      }
    }

    // Handle movement.
    movementHandler.current = ({ key }) => {
      player.checkIfIsMiddle()
      let collidingObstacles = []
      let eventListenerAttached = false

      const areColliding = () => {
        collidingObstacles = []

        obstacles.forEach(obstacle => {
          obstacle.checkIsColliding(inititalStep)
          collidingObstacles.push(obstacle.colliding)
        })

        return collidingObstacles
      }

      const animateColliding = () => {
        if (!isFirefox) {
          obstacles.forEach(obstacle => {
            if (
              !obstacle.triggered ||
              (obstacle.triggered && !obstacle.triggeredAgain)
            ) {
              obstacle.checkIsColliding(inititalStep)

              // Add or remove event listeners.
              if (obstacle.colliding) {
                document.addEventListener("keydown", handler)

                document.addEventListener("touchend", e => {
                  touch.x = e.changedTouches[0].clientX
                  touch.y = e.changedTouches[0].clientY
                  handler(e)
                })
                eventListenerAttached = true
                elAttached = true
              } else if (!obstacle.colliding && !eventListenerAttached) {
                document.removeEventListener("keydown", handler)
                elAttached = false

                document.removeEventListener("touchend", e => {
                  touch.x = e.changedTouches[0].clientX
                  touch.y = e.changedTouches[0].clientY
                  handler(e)
                })
              }

              // Animate collision.
              if (obstacle.colliding && !obstacle.collided && !obstacle.wait) {
                obstacle.animate()
                // Will stop on the last frame of the first row.
              }
            } else if (obstacle.triggered && obstacle.rowsTotal > 2) {
              if (obstacle.row !== 3) {
                obstacle.changeSpriteRow(3)
                obstacle.animate()
              }
            }
          })
        }
      }

      if (
        key === "w" ||
        key === "ц" ||
        direction === "up" ||
        key === "ArrowUp"
      ) {
        mainChar.changeSpriteRow(1)

        tick++
        player.direction = "up"

        rafid = requestAnimationFrame(draw)

        collidingObstacles = []
        collidingObstacles = areColliding()

        player.canMove = !collidingObstacles.some(el => el === true)
        if (player.canMove) player.checkIfCanMove()

        if (player.canMove) {
          if (camera.reachedUpperLimit()) {
            player.isMiddle = false
          }

          if (!player.isMiddle) {
            mainChar.move({ x: 0, y: -step })
            player.moveUp()
          } else if (player.isMiddle) {
            camera.moveUp()
            obstacles.forEach(obstacle => {
              obstacle.move({ x: 0, y: step })
            })
            items.forEach(item => {
              item.move({ x: 0, y: step })
            })
          }
        }

        animateColliding()
      }

      if (
        key === "s" ||
        key === "ы" ||
        direction === "down" ||
        key === "ArrowDown"
      ) {
        mainChar.changeSpriteRow(4)

        tick++
        player.direction = "down"
        rafid = requestAnimationFrame(draw)

        collidingObstacles = []
        collidingObstacles = areColliding()

        player.canMove = !collidingObstacles.some(el => el === true)
        if (player.canMove) player.checkIfCanMove()

        if (player.canMove) {
          if (camera.reachedLowerLimit()) {
            player.isMiddle = false
            step = inititalStep
          }

          if (!player.isMiddle) {
            mainChar.move({ x: 0, y: step })
            player.moveDown()
          } else if (player.isMiddle) {
            step = inititalStep
            camera.moveDown()
            obstacles.forEach(obstacle => {
              obstacle.move({ x: 0, y: -step })
            })
            items.forEach(item => {
              item.move({ x: 0, y: -step })
            })
          }
        }

        animateColliding()
      }

      if (
        key === "a" ||
        key === "ф" ||
        direction === "left" ||
        key === "ArrowLeft"
      ) {
        mainChar.changeSpriteRow(2)
        tick++
        player.direction = "left"

        rafid = requestAnimationFrame(draw)

        collidingObstacles = []

        collidingObstacles = areColliding()

        player.canMove = !collidingObstacles.some(el => el === true)
        if (player.canMove) player.checkIfCanMove()

        if (player.canMove) {
          mainChar.move({ x: -step, y: 0 })
          player.moveLeft()
        }

        animateColliding()
      }

      if (
        key === "d" ||
        key === "в" ||
        direction === "right" ||
        key === "ArrowRight"
      ) {
        mainChar.changeSpriteRow(3)
        tick++
        rafid = requestAnimationFrame(draw)
        player.direction = "right"

        collidingObstacles = []
        collidingObstacles = areColliding()

        player.canMove = !collidingObstacles.some(el => el === true)
        if (player.canMove) player.checkIfCanMove()

        if (player.canMove) {
          mainChar.move({ x: step, y: 0 })
          player.moveRight()
        }

        animateColliding()
      }
    }

    document.addEventListener("keydown", movementHandler.current)

    document.addEventListener("touchstart", e => {
      touchstartX = e.changedTouches[0].clientX
      touchstartY = e.changedTouches[0].clientY
    })

    document.addEventListener("touchmove", e => {
      touchendX = e.changedTouches[0].clientX
      touchendY = e.changedTouches[0].clientY

      if (touchendY < touchstartY - offset) {
        direction = "up"
      } else if (touchendY > touchstartY + offset) {
        direction = "down"
      } else if (touchendX < touchstartX - offset) {
        direction = "left"
      } else if (touchendX > touchstartX + offset) {
        direction = "right"
      }

      movementHandler.current(e)

      touchstartX = touchendX
      touchstartY = touchendY
    })

    document.addEventListener("touchend", () => {
      direction = undefined
    })

    const showE = item => {
      const choseE = () => {
        if (item.name === "business_card" || item.name === "paper")
          e_contact.draw()
        else {
          if (!isFirefox) e.draw()
        }
      }
      const setCoords = () => {
        e.destinationCoords = {
          x: item.destinationCoords.x + item.scale.x / 2 - e.width / 2,
          y: item.destinationCoords.y + item.scale.y / 2 - e.height / 2,
        }
        e_contact.destinationCoords = {
          x: item.destinationCoords.x + item.scale.x / 2 - e.width / 2,
          y: item.destinationCoords.y + item.scale.y / 2 - e.height / 2,
        }
      }
      // Show 'e' on an obstacle.
      if (
        item.colliding &&
        !item.triggered &&
        item.rowsTotal > 1 &&
        !item.wait
      ) {
        setCoords()
        choseE()
      } else if (
        item.triggered &&
        item.colliding &&
        item.collided &&
        !item.wait &&
        !item.triggeredAgain &&
        item.rowsTotal > 2
      ) {
        setCoords()
        choseE()
      } else if (
        item.colliding &&
        !item.triggered &&
        item.rowsTotal === 1 &&
        (item.name === "paper" || item.name === "business_card")
      ) {
        setCoords()
        choseE()
      }
    }

    const slideUp = () => {
      const form = document.getElementsByTagName("form")[0]
      if (form) form.style.animation = `${style.slideUp} 1s forwards`
    }

    const contactHandler = ({ key }) => {
      if (key === "e" || key === "у") {
        setOpenForm(true)

        document.removeEventListener("keydown", contactHandler)
        document.removeEventListener("keydown", movementHandler.current)

        const closeForm = () => {
          setOpenForm(false)
          document.addEventListener("keydown", movementHandler)
          rafid = requestAnimationFrame(draw)
        }
        containerRef.current.addEventListener("click", () => {
          slideUp()
          setTimeout(() => {
            closeForm()
          }, 1000)
        })
        document.addEventListener("keydown", e => {
          if (e.key === "Escape") {
            slideUp()
            setTimeout(() => {
              closeForm()
            }, 1000)
          }
        })
      }

      // Touch event.
      else if (touch.x && touch.y) {
        items.forEach(item => {
          console.log(item.name, item.colliding)
          // Find colliding item.
          if (item.colliding) {
            // If touched inside the item.
            if (
              touch.x >= item.destinationCoords.x &&
              touch.x <= item.destinationCoords.x + item.scale.x &&
              touch.y >= item.destinationCoords.y &&
              touch.y <= item.destinationCoords.y + item.scale.y
            ) {
              setOpenForm(true)
            }
          }
        })
      }
    }

    // Main draw func.
    draw = () => {
      const frame = (tick % mainChar.framesTotal) + 1
      let eventListenerAdded = false

      clear()

      items.forEach(item => {
        item.checkIsColliding(0)

        if (item.colliding) {
          eventListenerAdded = true
          if (!elAttached) {
            document.addEventListener("keydown", contactHandler)

            document.addEventListener("touchend", e => {
              touch.x = e.changedTouches[0].clientX
              touch.y = e.changedTouches[0].clientY
              contactHandler(e)
            })
          }
        } else if (!item.colliding && !eventListenerAdded) {
          document.removeEventListener("keydown", contactHandler)
        }

        item.draw()

        if (!elAttached) showE(item)

        // Load main character after paper.
        if (item.name === "paper" && item.isFirstLoad) {
          setTimeout(() => {
            if (isFirefox) mainChar.drawAllDots()
            mainChar.draw()
          }, 600)
        }
      })

      if (isFirefox) mainChar.drawAllDots()

      mainChar.changeFrame(frame)

      obstacles.forEach(obstacle => {
        obstacle.draw()
        showE(obstacle)
      })
      // Main character doesn't have time to appear before the items.
      mainChar.draw()
    }

    rafid = requestAnimationFrame(draw)
  }, [])

  // Blur canvas if form is open.
  useEffect(() => {
    if (openForm !== undefined && drawRef.current) {
      if (openForm) {
        containerRef.current.setAttribute("class", `${style.deEmphasized}`)
      } else {
        drawRef.current()
        document.addEventListener("keydown", movementHandler.current)
        containerRef.current.removeAttribute("class")
      }
    }
  }, [openForm])

  useEffect(() => {
    drawRef.current = draw
  }, [draw])

  return (
    <>
      <div ref={coverRef} className={style.cover} id="cover">
        <img alt="loading" src="/static/favicon.svg" />
      </div>
      <div ref={containerRef} />
      <Form openForm={openForm} setOpenForm={setOpenForm} />
    </>
  )
}

export default Index
